import React, { useState } from 'react';
import { Card, CardContent, Typography, Box, TextField, Grid, Button } from '@mui/material';
import { Send } from '@mui/icons-material';
import ExpandableCard from './ExpandableCard';

// Publica {"maquina":12,"nota":"..."} en el topic MQTT "nota" vía POST /api/maquina/nota (no se guarda)
const API_URL = process.env.REACT_APP_API_URL || 'http://31.97.100.31:5002/api';

const authHeaders = () => {
    const token = localStorage.getItem('token');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

const MaquinaNota = ({ theme }) => {
    const [maquina, setMaquina] = useState('');
    const [nota, setNota] = useState('');
    const [enviando, setEnviando] = useState(false);
    const [mensaje, setMensaje] = useState(null); // { ok, texto }

    const valido = Number.isInteger(Number(maquina)) && Number(maquina) > 0 && nota.trim() !== '';

    const enviar = async () => {
        if (!valido || enviando) return;
        setEnviando(true);
        setMensaje(null);
        try {
            const res = await fetch(`${API_URL}/maquina/nota`, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', ...authHeaders() },
                body: JSON.stringify({ maquina: Number(maquina), nota: nota.trim() }),
            });
            const data = await res.json().catch(() => ({}));
            if (res.ok && data.ok) {
                setMensaje({ ok: true, texto: `Enviado a máquina ${data.publicado.maquina}` });
                setNota('');
            } else {
                setMensaje({ ok: false, texto: res.status === 401 ? 'Sesión expirada, vuelva a iniciar sesión' : (data.error || 'No se pudo enviar') });
            }
        } catch {
            setMensaje({ ok: false, texto: 'Sin conexión con el servidor' });
        } finally {
            setEnviando(false);
        }
    };

    const inputSx = {
        '& .MuiInputBase-root': { backgroundColor: theme.cardBg2, color: theme.text, boxShadow: theme.shadowInset },
        '& .MuiInputBase-input': { color: theme.text, WebkitTextFillColor: theme.text },
        '& .MuiInputLabel-root': { color: theme.textSub },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.borderCard },
    };

    return (
        <Grid container spacing={1} sx={{ mb: 2 }}>
            <Grid item xs={12}>
                <ExpandableCard>
                    <Card sx={{ backgroundColor: theme.cardBg, color: theme.text, boxShadow: theme.shadow, border: `1px solid ${theme.borderCard}`, borderRadius: '10px' }}>
                        <CardContent sx={{ p: { xs: 0.5, sm: 2 }, pb: { xs: 0.5, sm: 2 } }}>
                            <Typography variant="h7" component="div" sx={{ borderBottom: `1px solid ${theme.border}`, pb: 1, mb: 1.5, color: theme.text, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                <Box component="span" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, fontWeight: 'bold' }}>Máquina · Enviar nota</Box>
                                {mensaje && (
                                    <Box component="span" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' }, color: mensaje.ok ? '#4caf50' : '#f44336' }}>
                                        {mensaje.texto}
                                    </Box>
                                )}
                            </Typography>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={4} md={2}>
                                    <TextField
                                        label="Máquina"
                                        type="number"
                                        value={maquina}
                                        onChange={(e) => setMaquina(e.target.value)}
                                        inputProps={{ min: 1, step: 1 }}
                                        size="small"
                                        fullWidth
                                        sx={inputSx}
                                    />
                                </Grid>
                                <Grid item xs={8} md={8}>
                                    <TextField
                                        label="Nota"
                                        value={nota}
                                        onChange={(e) => setNota(e.target.value)}
                                        onKeyDown={(e) => { if (e.key === 'Enter') enviar(); }}
                                        placeholder="revisar cuchilla"
                                        size="small"
                                        fullWidth
                                        sx={inputSx}
                                    />
                                </Grid>
                                <Grid item xs={12} md={2}>
                                    <Button variant="contained" fullWidth endIcon={<Send />} disabled={!valido || enviando} onClick={enviar}>
                                        {enviando ? 'Enviando…' : 'Enviar'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </ExpandableCard>
            </Grid>
        </Grid>
    );
};

export default MaquinaNota;
